"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
const faqsRouter = {
  path: '/faqs',
  component: _index.default,
  redirect: 'faqs',
  name: 'FAQs',
  meta: {
    title: 'faqs.title',
    icon: 'faq'
  },
  children: [{
    path: 'list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require( /* webpackChunkName: "admins-list" */'@/views/faqs/list.vue'))),
    name: 'FAQs',
    meta: {
      title: 'faqs.title',
      noCache: true,
      icon: 'faq'
    }
  }, {
    path: 'edit/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/faqs/manage.vue'))),
    name: 'Edit',
    props: {
      isEdit: true
    },
    meta: {
      title: 'faqs.edit',
      noCache: true,
      activeMenu: '/faqs/list',
      hidden: true
    }
  }, {
    path: 'add',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/faqs/manage.vue'))),
    name: 'Add',
    props: {
      isEdit: false
    },
    meta: {
      title: 'faqs.add',
      noCache: true,
      activeMenu: '/faqs/list',
      hidden: true
    }
  }]
};
var _default = exports.default = faqsRouter;